import React from 'react';
import { Mail, PenLine, Phone, User } from 'lucide-react';
import { Card, Field } from './Card';
import ActionButton from './ActionButton';
import CopyButton from './CopyButton';

/**
 * Legal guardian contact details.
 *
 * `actions` is the stack at the top right (Message User / Add Note in the design, W5 / W6).
 * `signatureLine` arrives already resolved: null for director bookings, which have none.
 */
const GuardianCard = ({ camper, isGuest, signatureLine, userDetailUrl, onResendConfirmation, actions }) => (
    <Card
        id="guardian"
        title="Legal Guardian"
        actions={actions ? <div className="tw-flex tw-flex-col tw-items-stretch tw-gap-1.5">{actions}</div> : null}
    >
        <div className="tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-3">
            {userDetailUrl
                ? <div className="tw-col-span-2">
                    <ActionButton variant="primary" icon={User} to={userDetailUrl}>User Detail</ActionButton>
                </div>
                : null}

            <Field
                icon={User}
                label="Name"
                className="tw-col-span-2"
                aside={<ActionButton variant="primary" icon={Mail} onClick={onResendConfirmation}>Resend Confirmation</ActionButton>}
            >
                {isGuest ? 'Guest User' : camper?.primaryName}
            </Field>

            <Field icon={Mail} label="Email" className="tw-col-span-2">
                {camper?.email
                    ? <span className="tw-inline-flex tw-items-center tw-gap-1 tw-break-all tw-text-brand-600">
                        {camper.email}
                        <CopyButton value={camper.email} label="email" />
                    </span>
                    : null}
            </Field>

            <Field icon={Phone} label="Primary phone" className="tw-col-span-2">
                {camper?.primaryPhone
                    ? <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-brand-600">
                        {camper.primaryPhone}
                        <CopyButton value={camper.primaryPhone} label="phone number" />
                    </span>
                    : null}
            </Field>

            <Field icon={User} label="Secondary contact">{camper?.secondaryContact}</Field>
            <Field icon={Phone} label="Secondary phone">{camper?.secondaryPhone}</Field>
            <Field icon={Mail} label="Secondary email" className="tw-col-span-2">{camper?.secondaryEmail}</Field>

            <Field icon={PenLine} label="Signature line">{signatureLine}</Field>
            <Field icon={PenLine} label="Signature">
                {camper?.signatureImage
                    ? <img src={camper.signatureImage} alt="Guardian signature" className="tw-max-h-16 tw-max-w-full tw-object-contain" />
                    : null}
            </Field>
        </div>
    </Card>
);

export default GuardianCard;
